import { render, staticRenderFns } from "./DocumentsList.vue?vue&type=template&id=6046e5e0&scoped=true&"
import script from "./DocumentsList.vue?vue&type=script&lang=ts&"
export * from "./DocumentsList.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentsList.vue?vue&type=style&index=0&id=6046e5e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6046e5e0",
  null
  
)

export default component.exports